(function () {
  "use strict";
  class UpsellPopup {
    constructor() {
      if (
        ((this.config = { enabled: !1, products: [] }),
        (this.overlay = document.getElementById("upsellPopupOverlay")),
        !!this.overlay)
      ) {
        if (
          ((this.popup = this.overlay.querySelector(".upsell-popup")),
          (this.configEl = document.getElementById("upsell-popup-config")),
          this.configEl)
        )
          try {
            this.config = JSON.parse(this.configEl.textContent);
          } catch (e) {
            console.error("[UpsellPopup] Failed to parse config:", e);
          }
        ((this.selectedProducts = {}),
          (this.mainProductFormData = null),
          (this.mainProductForm = null),
          (this.activeDrawer = null),
          (this.activePopover = null),
          (this.isSubmitting = !1),
          (this.integrationHooks = null),
          (this.lockedScrollY = null),
          (this.variantDataCache = new Map()),
          this.clearStaleScrollLock(),
          this.init());
      }
    }
    init() {
      !this.config.enabled ||
        this.config.products.length === 0 ||
        this.bindEvents();
    }
    bindEvents() {
      const closeBtn = this.overlay.querySelector("[data-upsell-close]");
      (closeBtn &&
        closeBtn.addEventListener("click", (e) => {
          (e.preventDefault(), this.onCloseClick());
        }),
        (this.onDocumentKeydown = (e) => {
          e.key === "Escape" && this.isOpen() && this.onCloseClick();
        }),
        document.addEventListener("keydown", this.onDocumentKeydown),
        this.overlay
          .querySelectorAll("[data-upsell-product]")
          .forEach((item) => {
            item.addEventListener("click", () => this.toggleProduct(item));
          }),
        this.overlay
          .querySelector("[data-upsell-yes]")
          ?.addEventListener("click", (e) => {
            (e.preventDefault(), this.submitSelection());
          }),
        this.overlay
          .querySelector("[data-upsell-no]")
          ?.addEventListener("click", (e) => {
            (e.preventDefault(), this.submitWithoutUpsell());
          }));
      const continueBtn = this.overlay.querySelector("[data-upsell-continue]");
      continueBtn &&
        continueBtn.addEventListener("click", (e) => {
          (e.preventDefault(), this.onContinueShopping());
        });
      const checkoutBtn = this.overlay.querySelector("[data-upsell-checkout]");
      checkoutBtn &&
        checkoutBtn.addEventListener("click", (e) => {
          (e.preventDefault(), this.onGoToCheckout());
        });
    }
    initFormInterception(container = document) {
      if (!this.isEnabled() || this.disposed) return;
      this.ownedFormHandlers ||= new Map();
      const selector = 'form[is="product-form"], form[id*="product-form"]',
        forms = [
          ...(container.matches?.(selector) ? [container] : []),
          ...container.querySelectorAll(selector),
        ];
      for (const form of forms) {
        if (
          !this.isEligibleForm(form) ||
          form.dataset.upsellInitialized === "true" ||
          ((form.dataset.upsellInitialized = "true"),
          form.dataset.upsellRequiresImageUpload !== "false")
        )
          continue;
        const handler = (event) => {
          this.isEnabled() &&
            (event.preventDefault(),
            event.stopPropagation(),
            event.stopImmediatePropagation(),
            this.openForForm(form));
        };
        (form.addEventListener("submit", handler, !0),
          this.ownedFormHandlers.set(form, handler));
      }
    }
    observeDynamicForms() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            node.nodeType === 1 &&
              (node.matches?.(
                'form[is="product-form"], form[id*="product-form"], quick-buy-drawer, quick-buy-popover, .drawer__content, .popover__content',
              )
                ? setTimeout(() => this.initFormInterception(node), 100)
                : node.querySelector?.(
                    'form[is="product-form"], form[id*="product-form"]',
                  ) && setTimeout(() => this.initFormInterception(node), 100));
          });
        });
      });
      (observer.observe(document.body, { childList: !0, subtree: !0 }),
        (this.formObserver = observer));
    }
    isEnabled() {
      return (
        !this.disposed && this.config.enabled && this.config.products.length > 0
      );
    }
    isOpen() {
      return this.overlay && this.overlay.classList.contains("active");
    }
    isEligibleForm(productForm) {
      return !productForm || !productForm.isConnected
        ? !1
        : !productForm.closest("quick-buy-drawer, .drawer--quick-buy");
    }
    async resolveSelectedVariantId(productForm) {
      const variantSelector = productForm
          .closest(
            ".product-form, .quick-buy-product, quick-buy-drawer, quick-buy-popover, .drawer__content, .popover__content",
          )
          ?.querySelector(".product-form__variants"),
        productHandle = variantSelector?.getAttribute("handle"),
        selectedOptions = variantSelector
          ? Array.from(
              variantSelector.querySelectorAll(
                'input[name^="option"]:checked, select[name^="option"]',
              ),
            ).map((input) => input.value)
          : [];
      if (!productHandle || selectedOptions.length === 0) return null;
      try {
        let productData = this.variantDataCache.get(productHandle);
        if (!productData) {
          const response = await fetch(
            `/products/${encodeURIComponent(productHandle)}.js`,
            { credentials: "same-origin" },
          );
          if (!response.ok) return null;
          ((productData = await response.json()),
            this.variantDataCache.set(productHandle, productData));
        }
        const variant = productData.variants?.find((candidate) =>
          candidate.options?.every(
            (option, index) => option === selectedOptions[index],
          ),
        );
        return variant?.id ? String(variant.id) : null;
      } catch (error) {
        return (
          console.warn(
            "[UpsellPopup] Unable to resolve the selected variant:",
            error,
          ),
          null
        );
      }
    }
    async serializeForm(productForm) {
      if (!this.isEligibleForm(productForm)) return null;
      const formData = new FormData(productForm);
      const module = Array.from(document.querySelectorAll('ddw-sku-base-personalizer[data-ddw-sku-text="1"]')).find(step => step.ownsForm?.(productForm));
      const selectedVariantId = module ? module.currentVariant(productForm)?.id : await this.resolveSelectedVariantId(productForm);
      if (module && !selectedVariantId) return null;
      if (selectedVariantId) formData.set('id', String(selectedVariantId));
      module?.writeData(formData, productForm);
      for (const name of ['option1', 'option2', 'option3']) formData.delete(name);
      return formData;
    }
    async openForForm(productForm) {
      if (
        !this.isEnabled() ||
        !this.isEligibleForm(productForm) ||
        this.isSubmitting ||
        this.isOpen() ||
        this.textStepPending
      )
        return !1;
      const formData = await this.serializeForm(productForm);
      return formData ? this.open(formData, productForm) : !1;
    }
    async open(mainFormData, mainForm, integrationHooks = null) {
      if (this.disposed || !this.isEnabled() || !this.isEligibleForm(mainForm) || this.isSubmitting || this.isOpen() || this.textStepPending) return false;
      this.textStepPending = true;
      this.confirmedTextStep = null;
      let accepted = false, step = null;
      try {
        // Do not fall back to the old all-variant module when a SKU-scoped module owns this product.
        const module = Array.from(document.querySelectorAll('ddw-sku-base-personalizer[data-ddw-sku-text="1"]')).find(node => {
          try { return JSON.parse(node.dataset.variantIds || '[]').map(String).includes(String(mainFormData?.get('id') || mainForm.elements.namedItem('id')?.value || '')); } catch { return false; }
        });
        if (module && typeof module.matches !== 'function') {
          await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => reject(new Error('Personalization component did not load')), 7000);
            customElements.whenDefined(module.localName).then(() => { clearTimeout(timeout); resolve(); });
          });
        }
        if (module?.ownsForm(mainForm)) {
          const variant = module.currentVariant(mainForm);
          if (!variant) throw new Error('The selected variant is unavailable');
          mainFormData.set('id', String(variant.id));
        }
        if (this.disposed || !this.isEligibleForm(mainForm)) return false;
        step = this.getTextStep(mainFormData, mainForm);
        if (!step) {
          this.clearInactiveText(mainFormData, mainForm);
          this.openSelector(mainFormData, mainForm, integrationHooks);
          accepted = true; return true;
        }
        this.activeTextStep = step;
        if (typeof step.request !== 'function') {
          await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => reject(new Error('Personalization component did not load')), 7000);
            customElements.whenDefined(step.localName).then(() => { clearTimeout(timeout); resolve(); });
          });
        }
        if (this.disposed || !step.isConnected || this.getTextStep(mainFormData, mainForm) !== step) return false;
        accepted = await step.request(mainFormData, mainForm);
        if (accepted && !this.disposed && this.isEligibleForm(mainForm) && step.isConnected && this.getTextStep(mainFormData, mainForm) === step) {
          this.confirmedTextStep = step;
          this.openSelector(mainFormData, mainForm, integrationHooks);
          return true;
        }
        accepted = false;
      } catch (error) {
        console.error('[UpsellPopup] Personalization could not open:', error.message);
        alert('Personalization could not open. Please refresh and try again.');
      } finally {
        this.textStepPending = false; this.activeTextStep = null;
        if (!accepted && typeof integrationHooks?.onCancel === 'function') integrationHooks.onCancel();
      }
      return false;
    }
    getTextStep(data, form) {
      if (!this.isEligibleForm(form) || form.dataset.upsellRequiresImageUpload === 'false' || !data?.get('properties[Generated Image]')) return null;
      const variantId = String(data.get('id') || ''); if (!variantId) return null;
      const modules = Array.from(document.querySelectorAll('ddw-sku-base-personalizer[data-ddw-sku-text="1"]'));
      for (const step of modules) {
        if (!step.isConnected || step.hidden || step.closest('.shopify-section[hidden]')) continue;
        try {
          if (!JSON.parse(step.dataset.variantIds || '[]').map(String).includes(variantId)) continue;
          const config = step.config || JSON.parse(step.querySelector('[data-config]').textContent);
          if (config.formId && config.formId !== form.id) continue;
          return typeof step.matches === 'function' ? (step.matches(form, data) ? step : null) : step;
        } catch { return null; }
      }
      return Array.from(document.querySelectorAll('ddw-base-text-popup[data-ddw-base-text-popup="T2"]')).find(step => {
        if (!step.isConnected || step.hidden || step.closest('.shopify-section[hidden]')) return false;
        try {
          const variants = JSON.parse(step.dataset.variantIds || '[]').map(String);
          return variants.includes(variantId) || step.dataset.selectedVariantId === variantId;
        } catch { return false; }
      }) || null;
    }
    validateTextStep(data, form) {
      const step = this.getTextStep(data, form);
      return this.confirmedTextStep
        ? step === this.confirmedTextStep &&
            step.isConnected &&
            step.isConfirmedFor(form, data) === !0
        : !step;
    }
    clearInactiveText(data, form) {
      if (!form) return;
      for (const holder of form.querySelectorAll('[data-ddw-text-owner]')) {
        for (const input of holder.querySelectorAll('input[name]')) data?.delete(input.name);
        holder.remove();
      }
      for (const step of document.querySelectorAll('ddw-base-text-popup, ddw-sku-base-personalizer[data-ddw-sku-text="1"]')) step.clearForm?.(form, data);
    }
    destroy() {
      ((this.disposed = !0),
        this.activeTextStep?.cancel(),
        this.formObserver?.disconnect(),
        this.onDocumentKeydown &&
          document.removeEventListener("keydown", this.onDocumentKeydown));
      for (const [form, handler] of this.ownedFormHandlers || [])
        (form.removeEventListener("submit", handler, !0),
          delete form.dataset.upsellInitialized);
      (this.ownedFormHandlers?.clear(), this.overlay && this.close());
    }
    openSelector(mainFormData, mainForm, integrationHooks = null) {
      ((this.mainProductFormData = mainFormData),
        (this.mainProductForm = mainForm),
        (this.integrationHooks = integrationHooks),
        (this.isSubmitting = !1));
      const drawer = document.querySelector("quick-buy-drawer[open]"),
        popover = document.querySelector("quick-buy-popover[open]");
      (drawer &&
        ((this.activeDrawer = drawer),
        drawer._focusTrap &&
          drawer._focusTrap.updateContainerElements &&
          drawer._focusTrap.updateContainerElements([drawer, this.overlay])),
        popover &&
          ((this.activePopover = popover),
          popover._focusTrap &&
            popover._focusTrap.updateContainerElements &&
            popover._focusTrap.updateContainerElements([
              popover,
              this.overlay,
            ])),
        this.resetSelectionState(),
        this.overlay.classList.add("active"),
        this.lockPageScroll());
    }
    close() {
      (this.activeTextStep?.cancel(), (this.confirmedTextStep = null));
      const onCancel = this.integrationHooks?.onCancel;
      if (
        ((this.integrationHooks = null),
        this.overlay.classList.remove("active"),
        this.unlockPageScroll(),
        (this.isSubmitting = !1),
        this.activeDrawer &&
          this.activeDrawer._focusTrap &&
          this.activeDrawer._focusTrap.updateContainerElements &&
          this.activeDrawer._focusTrap.updateContainerElements([
            this.activeDrawer,
          ]),
        this.activePopover &&
          this.activePopover._focusTrap &&
          this.activePopover._focusTrap.updateContainerElements &&
          this.activePopover._focusTrap.updateContainerElements([
            this.activePopover,
          ]),
        (this.activeDrawer = null),
        (this.activePopover = null),
        this.resetPopup(),
        typeof onCancel == "function")
      )
        try {
          onCancel();
        } catch (error) {
          console.warn(
            "[UpsellPopup] Integration cancel callback failed:",
            error,
          );
        }
    }
    finishIntegration(callbackName, payload) {
      const callback = this.integrationHooks?.[callbackName];
      if (((this.integrationHooks = null), typeof callback == "function"))
        try {
          callback(payload);
        } catch (error) {
          console.warn(
            `[UpsellPopup] Integration ${callbackName} callback failed:`,
            error,
          );
        }
    }
    lockPageScroll() {
      if (this.lockedScrollY !== null) return;
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      ((this.lockedScrollY = scrollY),
        document.documentElement.style.setProperty(
          "--upsell-popup-scroll-y",
          `-${scrollY}px`,
        ),
        document.documentElement.classList.add("upsell-popup-scroll-lock"),
        document.body.classList.add("upsell-popup-scroll-lock"));
    }
    clearStaleScrollLock() {
      this.overlay.classList.contains("active") ||
        (document.documentElement.classList.remove("upsell-popup-scroll-lock"),
        document.body.classList.remove("upsell-popup-scroll-lock"),
        document.documentElement.style.removeProperty(
          "--upsell-popup-scroll-y",
        ));
    }
    unlockPageScroll() {
      if (this.lockedScrollY === null) return;
      const scrollY = this.lockedScrollY;
      (document.documentElement.classList.remove("upsell-popup-scroll-lock"),
        document.body.classList.remove("upsell-popup-scroll-lock"),
        document.documentElement.style.removeProperty(
          "--upsell-popup-scroll-y",
        ),
        (this.lockedScrollY = null),
        window.scrollTo(0, scrollY));
    }
    onCloseClick() {
      this.isSubmitting || this.close();
    }
    resetPopup() {
      ((this.selectedProducts = {}),
        (this.mainProductFormData = null),
        (this.mainProductForm = null),
        this.hideLoading(),
        this.hideCompletion());
    }
    resetSelectionState() {
      ((this.selectedProducts = {}),
        this.overlay
          .querySelectorAll("[data-upsell-product]")
          .forEach((item) => {
            const selected = item.dataset.defaultSelected === "true";
            this.setProductSelected(item, selected);
          }));
    }
    toggleProduct(item) {
      this.setProductSelected(
        item,
        item.getAttribute("aria-pressed") !== "true",
      );
    }
    setProductSelected(item, selected) {
      const variantId = item.dataset.variantId;
      (item.classList.toggle("is-selected", selected),
        item.setAttribute("aria-pressed", String(selected)),
        selected && variantId
          ? (this.selectedProducts[variantId] = {
              variantId,
              quantity: 1,
              properties: {},
            })
          : variantId && delete this.selectedProducts[variantId]);
    }
    submitSelection() {
      this.isSubmitting || ((this.isSubmitting = !0), this.complete());
    }
    submitWithoutUpsell() {
      this.isSubmitting ||
        ((this.isSubmitting = !0),
        (this.selectedProducts = {}),
        this.complete());
    }
    async complete() {
      const cartAddUrl =
        window.themeVariables?.routes?.cartAddUrl || "/cart/add";
      this.showLoading();
      try {
        if (this.mainProductForm && this.mainProductForm.isConnected) {
          const freshFormData = await this.serializeForm(this.mainProductForm);
          freshFormData && (this.mainProductFormData = freshFormData);
        }
        if (
          !this.validateTextStep(this.mainProductFormData, this.mainProductForm)
        ) {
          (this.hideLoading(),
            this.close(),
            alert(
              "Please review your personalization again before adding to cart.",
            ));
          return;
        }
        const mainProductId = this.mainProductFormData?.get("id");
        if (!this.mainProductFormData || !mainProductId) {
          (console.error(
            "[UpsellPopup] Main product data is unavailable, aborting add to cart",
            {
              hasForm: !!this.mainProductForm,
              formConnected: !!this.mainProductForm?.isConnected,
              hasFormData: !!this.mainProductFormData,
            },
          ),
            this.hideLoading(),
            this.close(),
            alert("Unable to add the main product. Please try again."));
          return;
        }
        const itemsToAdd = [];
        if (this.mainProductFormData) {
          const mainProductQuantity =
            this.mainProductFormData.get("quantity") || 1;
          if (mainProductId) {
            const mainItem = {
                id: parseInt(mainProductId),
                quantity: parseInt(mainProductQuantity),
              },
              properties = {};
            for (const [key, value] of this.mainProductFormData.entries())
              if (key.startsWith("properties[") && value) {
                const propName = key
                  .replace("properties[", "")
                  .replace("]", "");
                properties[propName] = value;
              }
            const mainFormId = this.mainProductForm?.getAttribute?.("id") || "",
              readLiveHiddenValue = (id) => {
                const scoped = this.mainProductForm?.querySelector?.(
                  `[id="${id}"]`,
                );
                if (scoped && scoped.value) return scoped.value.trim();
                if (!mainFormId) return "";
                const linked = Array.from(
                  document.querySelectorAll(`[id="${id}"]`),
                ).find((input) => input.getAttribute("form") === mainFormId);
                return linked && linked.value ? linked.value.trim() : "";
              };
            ([
              ["Generated Image", "ai-custom-image-url"],
              ["_Display Image", "ai-custom-image-url-display"],
              ["_JobID", "ai-custom-image-url-job-id"],
              ["Generated Image 2", "ai-custom-image-url-2"],
              ["_Display Image 2", "ai-custom-image-url-2-display"],
              ["_JobID 2", "ai-custom-image-url-2-job-id"],
            ].forEach(([propName, elementId]) => {
              if (!properties[propName]) {
                const liveValue = readLiveHiddenValue(elementId);
                liveValue && (properties[propName] = liveValue);
              }
            }),
              Object.keys(properties).length > 0 &&
                (mainItem.properties = properties));
            const requiresImageUpload =
                this.mainProductForm?.dataset.upsellRequiresImageUpload !==
                "false",
              formScope = this.mainProductForm?.closest(
                ".product-form, .quick-buy-product, quick-buy-drawer, quick-buy-popover, .drawer__content, .popover__content",
              ),
              secondUploadContainer = formScope?.querySelector(
                '.ai-upload-container[data-upload-index="2"]',
              ),
              secondUploadColumn =
                secondUploadContainer?.closest(".ai-upload-col"),
              requiresSecondImage = !!(
                secondUploadContainer &&
                window.getComputedStyle(secondUploadContainer).display !==
                  "none" &&
                (!secondUploadColumn ||
                  window.getComputedStyle(secondUploadColumn).display !==
                    "none")
              ),
              missingImageIndex =
                requiresImageUpload && !properties["Generated Image"]
                  ? 1
                  : requiresImageUpload &&
                      requiresSecondImage &&
                      !properties["Generated Image 2"]
                    ? 2
                    : 0;
            if (missingImageIndex) {
              (console.error(
                `[UpsellPopup] Missing Generated Image${missingImageIndex === 2 ? " 2" : ""}, aborting add to cart`,
                {
                  productId: mainProductId,
                  formId: mainFormId,
                  requiresSecondImage,
                  capturedKeys: Array.from(this.mainProductFormData.keys()),
                },
              ),
                this.hideLoading(),
                this.close(),
                alert(
                  `Please upload ${missingImageIndex === 2 ? "the second photo" : "your photo"} before continuing.`,
                ));
              const uploadContainer = formScope?.querySelector(
                `.ai-upload-container${missingImageIndex === 2 ? '[data-upload-index="2"]' : ':not([data-upload-index="2"])'}`,
              );
              uploadContainer?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              const trigger = uploadContainer?.querySelector(
                missingImageIndex === 2
                  ? "#ai-upload-trigger-2"
                  : "#ai-upload-trigger",
              );
              trigger && trigger.classList.add("validation-error");
              return;
            }
            itemsToAdd.push(mainItem);
          }
        }
        const jquery = window.jQuery;
        jquery &&
          jquery(
            '.accessories-item input[data-action="bundle-add-to-cart"]:checked',
          ).each(function (index, ele) {
            const itemId = jquery(ele).attr("data-product-variant-id"),
              itemQuantity =
                parseInt(jquery(ele).attr("data-product-qty")) || 1;
            itemId &&
              itemsToAdd.push({ id: parseInt(itemId), quantity: itemQuantity });
          });
        for (const product of Object.values(this.selectedProducts)) {
          const upsellItem = {
            id: parseInt(product.variantId),
            quantity: product.quantity || 1,
          };
          (Object.keys(product.properties).length > 0 &&
            (upsellItem.properties = product.properties),
            itemsToAdd.push(upsellItem));
        }
        if (itemsToAdd.length > 0) {
          const mainItem = itemsToAdd[0],
            cartSnapshot = mainItem?.properties?.["Generated Image"]
              ? await window.GeneratedImageCartGuard.snapshot()
              : null,
            response = await fetch(`${cartAddUrl}.js`, {
              body: JSON.stringify({ items: itemsToAdd }),
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              credentials: "same-origin",
            });
          if (!response.ok)
            throw new Error(`Cart add failed: ${response.status}`);
          let responseData;
          try {
            responseData = await response.json();
          } catch (parseError) {
            throw (
              cartSnapshot &&
                (await window.GeneratedImageCartGuard.verify(
                  null,
                  mainItem,
                  cartSnapshot,
                )),
              parseError
            );
          }
          cartSnapshot &&
            (await window.GeneratedImageCartGuard.verify(
              responseData,
              mainItem,
              cartSnapshot,
            ));
        }
        (await this.refreshCart(),
          this.hideLoading(),
          this.showCompletion(),
          this.clearSelectedImages(),
          this.finishIntegration("onComplete"));
      } catch (error) {
        (console.error("[UpsellPopup] Error adding products to cart:", error),
          this.finishIntegration("onError", error),
          this.hideLoading(),
          this.close(),
          alert("Unable to add the product safely. Please try again."));
      }
    }
    async addAccessoriesToCart(cartAddUrl) {
      const jquery = window.jQuery;
      if (!jquery) return;
      const allCheckedInputs = jquery(
        '.accessories-item input[data-action="bundle-add-to-cart"]:checked',
      );
      if (allCheckedInputs.length === 0) return;
      const accessoriesForm = new FormData();
      (allCheckedInputs.each(function (index, ele) {
        const itemId = jquery(ele).attr("data-product-variant-id"),
          itemQuantity = parseInt(jquery(ele).attr("data-product-qty")) || 1;
        (accessoriesForm.set(`items[${index}]id`, itemId),
          accessoriesForm.set(`items[${index}]quantity`, itemQuantity));
      }),
        await fetch(`${cartAddUrl}.js`, {
          body: accessoriesForm,
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
          credentials: "same-origin",
        }));
    }
    async refreshCart() {
      try {
        const cartUrl = window.themeVariables?.routes?.cartUrl || "/cart",
          cartContent = await (
            await fetch(`${cartUrl}.js?sections=mini-cart`, {
              headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              credentials: "same-origin",
            })
          ).json();
        (document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: !0,
            detail: { cart: cartContent },
          }),
        ),
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: !0,
              detail: { cart: cartContent, openMiniCart: !1 },
            }),
          ));
      } catch (error) {
        console.error("[UpsellPopup] Error refreshing cart:", error);
      }
    }
    showLoading() {
      const loadingEl = this.overlay.querySelector("[data-upsell-loading]");
      loadingEl && loadingEl.classList.add("active");
    }
    hideLoading() {
      const loadingEl = this.overlay.querySelector("[data-upsell-loading]");
      loadingEl && loadingEl.classList.remove("active");
    }
    showSuccess() {
      const successEl = this.overlay.querySelector("[data-upsell-success]");
      successEl && successEl.classList.add("active");
    }
    hideSuccess() {
      const successEl = this.overlay.querySelector("[data-upsell-success]");
      successEl && successEl.classList.remove("active");
    }
    showCompletion() {
      const completionEl = this.overlay.querySelector(
        "[data-upsell-completion]",
      );
      completionEl && completionEl.classList.add("active");
    }
    hideCompletion() {
      const completionEl = this.overlay.querySelector(
        "[data-upsell-completion]",
      );
      completionEl && completionEl.classList.remove("active");
    }
    trackCompletionButtonClick(eventName) {
      if (!window.GtagUtils || typeof window.GtagUtils.sendEvent != "function")
        return;
      const productInfo =
        typeof window.GtagUtils.getProductInfo == "function"
          ? window.GtagUtils.getProductInfo()
          : {};
      window.GtagUtils.sendEvent(eventName, {
        product_id: productInfo.product_id || "",
        product_variant_id: String(this.mainProductFormData?.get("id") || ""),
        upsell_item_count: Object.keys(this.selectedProducts).length,
        section_id: this.config.sectionId || "",
        page_path: window.location.pathname,
      });
    }
    onContinueShopping() {
      (this.trackCompletionButtonClick("upsell_continue_shopping_click"),
        this.hideCompletion(),
        this.close());
    }
    onGoToCheckout() {
      (this.trackCompletionButtonClick("upsell_checkout_click"),
        this.hideCompletion(),
        this.close(),
        this.goToCheckout());
    }
    clearSelectedImages() {
      const clearInContext = (context, contextName) => {
          const hiddenInput1 = context.querySelector("#ai-custom-image-url"),
            hiddenInput2 = context.querySelector("#ai-custom-image-url-2"),
            hiddenInputJob1 = context.querySelector(
              "#ai-custom-image-url-job-id",
            ),
            hiddenInputJob2 = context.querySelector(
              "#ai-custom-image-url-2-job-id",
            );
          (hiddenInput1 && (hiddenInput1.value = ""),
            hiddenInput2 && (hiddenInput2.value = ""),
            hiddenInputJob1 && (hiddenInputJob1.value = ""),
            hiddenInputJob2 && (hiddenInputJob2.value = ""),
            context
              .querySelectorAll(
                'input[name="properties[Generated Image]"], input[name="properties[Generated Image 2]"], input[name="properties[Custom Image]"], input[name="properties[_Custom Image]"], input[name="properties[Custom Image 2]"], input[name="properties[_Custom Image 2]"], input[name="properties[_JobID]"], input[name="properties[_JobID 2]"]',
              )
              .forEach((input) => {
                input.value = "";
              }));
          const previewImg1 = context.querySelector("#ai-upload-preview"),
            uploadBtn1 = context.querySelector("#ai-upload-trigger"),
            statusDiv1 = context.querySelector("#ai-upload-status");
          if (
            (previewImg1 &&
              ((previewImg1.src = ""),
              previewImg1.style.removeProperty("display")),
            uploadBtn1)
          ) {
            uploadBtn1.classList.remove("has-image", "uploaded");
            const icon1 = uploadBtn1.querySelector(".ai-upload-icon"),
              text1 = uploadBtn1.querySelector(".ai-upload-text");
            (icon1 && icon1.style.removeProperty("display"),
              text1 && text1.style.removeProperty("display"));
          }
          statusDiv1 &&
            ((statusDiv1.style.display = "none"),
            (statusDiv1.className = "ai-upload-status"),
            (statusDiv1.textContent = ""));
          const previewImg2 = context.querySelector("#ai-upload-preview-2"),
            uploadBtn2 = context.querySelector("#ai-upload-trigger-2"),
            statusDiv2 = context.querySelector("#ai-upload-status-2");
          if (
            (previewImg2 &&
              ((previewImg2.src = ""),
              previewImg2.style.removeProperty("display")),
            uploadBtn2)
          ) {
            uploadBtn2.classList.remove("has-image", "uploaded");
            const icon2 = uploadBtn2.querySelector(".ai-upload-icon"),
              text2 = uploadBtn2.querySelector(".ai-upload-text");
            (icon2 && icon2.style.removeProperty("display"),
              text2 && text2.style.removeProperty("display"));
          }
          statusDiv2 &&
            ((statusDiv2.style.display = "none"),
            (statusDiv2.className = "ai-upload-status"),
            (statusDiv2.textContent = ""));
          const imagesGrid = context.querySelector(".ai-generated-images-grid");
          (imagesGrid && (imagesGrid.innerHTML = ""),
            context
              .querySelectorAll(
                ".ai-upload-input, #ai-file-input, #ai-file-input-2",
              )
              .forEach((input) => {
                input.value = "";
              }));
        },
        drawer =
          this.activeDrawer || document.querySelector("quick-buy-drawer[open]");
      drawer && clearInContext(drawer, "drawer");
      const popover =
        this.activePopover || document.querySelector("quick-buy-popover[open]");
      (popover && clearInContext(popover, "popover"),
        clearInContext(document, "main page"),
        window.FilePond &&
          document.querySelectorAll(".filepond").forEach((pond) => {
            const instance = FilePond.find(pond);
            instance && instance.removeFiles();
          }),
        document.dispatchEvent(
          new CustomEvent("upsell:images-cleared", {
            detail: { form: this.mainProductForm },
          }),
        ));
    }
    goToCheckout() {
      const form = document.createElement("form");
      ((form.method = "POST"),
        (form.action = window.themeVariables?.routes?.cartUrl || "/cart"));
      const checkoutInput = document.createElement("input");
      ((checkoutInput.type = "hidden"),
        (checkoutInput.name = "checkout"),
        (checkoutInput.value = ""),
        form.appendChild(checkoutInput),
        document.body.appendChild(form),
        form.submit());
    }
  }
  function initUpsellPopup() {
    (window.upsellPopup?.destroy?.(),
      (window.upsellPopup = new UpsellPopup()),
      window.upsellPopup.initFormInterception(),
      window.upsellPopup.observeDynamicForms());
  }
  (document.addEventListener("shopify:section:load", (event) => {
    (event.target.matches?.(".shopify-section--product-upsell-popup") ||
      event.target.querySelector?.("[data-upsell-popup]")) &&
      initUpsellPopup();
  }),
    document.addEventListener("shopify:section:unload", (event) => {
      event.detail?.sectionId === window.upsellPopup?.config?.sectionId &&
        window.upsellPopup.destroy?.();
    }),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", initUpsellPopup)
      : initUpsellPopup());
})();
//# sourceMappingURL=/cdn/shop/t/2/assets/upsell-popup.js.map?v=124341564209732519191792068454
